export default { sha: '31735b80dec1c2e95cac760389099fd7a06819ac', buildNumber: 'undefined' }
